import moduleReducers from "modules/queryStringReducers"

export default {
  ...moduleReducers,
}
